<template>
  <MRow :gutter="0">
    <MCol :lg="12" :sm="12" auto-size>
      <MRow :gutter="0">
        <MCol :size="6" class="pr-2">
          <FlotoFormItem
            id="allocation-status"
            rules="required"
            :label="$tc('status')"
          >
            <FlotoDropdownPicker
              v-model="formData.status"
              as-input
              searchable
              :options="allocationStatusOptions"
            />
          </FlotoFormItem>
        </MCol>
        <MCol :size="6" class="pl-2">
          <FlotoFormItem
            id="quantity-input"
            :rules="{
              required: true,
              nonzero: true,
              ...(resource.AllocationQuantity
                ? // eslint-disable-next-line
                  { max_value: resource.availableQuantity }
                : {}),
            }"
            :label="$tc('quantity')"
          >
            <MInputNumber
              v-model="formData.quantity"
              :disabled="disabled"
              :placeholder="$tc('quantity')"
              :precision="0"
            />
            {{ $tc('available') }} {{ $tc('quantity') }}:
            {{ resource.availableQuantity }}
          </FlotoFormItem>
        </MCol>
      </MRow>
      <MRow :gutter="0">
        <MCol :size="6" class="pr-2">
          <FlotoFormItem
            id="allocated-to"
            :label="`${$tc('allocate')} ${$tc('to')}`"
          >
            <FlotoRequesterPicker v-model="formData.allocatedUserId" as-input />
          </FlotoFormItem>
        </MCol>
        <MCol :size="6" class="pl-2">
          <FlotoFormItem id="location-picker" :label="`${$tc('location')}`">
            <FlotoLocationPicker v-model="formData.locationId" />
          </FlotoFormItem>
        </MCol>
      </MRow>
      <MRow :gutter="0">
        <MCol :size="6" class="pr-2">
          <FlotoFormItem id="department-picker" :label="$tc('department')">
            <FlotoDepartmentPicker v-model="formData.departmentId" />
          </FlotoFormItem>
        </MCol>
        <MCol :size="6" class="pl-2">
          <FlotoFormItem id="asset-picker" :label="`${$tc('asset')}`">
            <AssetPickerDrawer
              v-model="formData.assetId"
              as-input
              :module-name="$constants.ASSET_HARDWARE"
            />
          </FlotoFormItem>
        </MCol>
      </MRow>
      <FlotoFormItem
        id="description-input"
        v-model="formData.description"
        :placeholder="$tc('description_instruction')"
        :label="$tc('description')"
        :rows="2"
        type="textarea"
      />
    </MCol>
  </MRow>
</template>

<script>
import AssetPickerDrawer from '@components/data-picker/asset-picker-drawer'
import { allocationStatusOptions } from '../../helpers/option-map.js'
export default {
  name: 'AllocationForm',
  components: { AssetPickerDrawer },
  props: {
    formData: {
      type: Object,
      required: true,
      default() {
        return {}
      },
    },
    resource: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    this.allocationStatusOptions = allocationStatusOptions()
    return {}
  },
  computed: {
    disabled() {
      if (this.formData.id && !this.formData.canEdit) {
        return true
      }
      return false
    },
  },
}
</script>
